import { css } from '@emotion/react';
import { flex, margins, themed } from '@spotnana/blocks/src/utils/styling';

export const link_white = themed(
  ({ palette }) => css`
    cursor: pointer;
    color: ${palette.text.inverse};
    text-decoration-color: ${palette.text.inverse};
    :visited {
      color: ${palette.text.inverse};
      text-decoration-color: ${palette.text.inverse};
    }
    :hover {
      color: ${palette.text.secondaryInverse};
      text-decoration-color: ${palette.text.secondaryInverse};
    }
  `,
);
export const tooltip_icon_container = css`
  ${margins.xl.half}
  ${flex.init}
  ${flex.align.center}
  margin-bottom: 2px;
`;
